module.exports = __webpack_public_path__ + "img/24a)Reichstag.jpg";